import {Asset} from './asset.model';
import {AssetPackageDto} from '../asset-package';

export class BudgetInfo {
  assetRnrBudget: number;
  assetHaulingBudget: number;
  rnrRollup: number;
  haulingRollup: number;
  rnrNotToExceed: number;
  haulingNotToExceed: number;
  isEditable: boolean;
  opportunityCurrency: string;
  oldRnrBudget: number;
  oldHaulingBudget: number;
  assetPackageRnRNotToExceed: number;
  assetPackageHaulingNotToExceed: number;
  cleanBudget: number;
  sandBlastAndPaintBudget: number;
  upholsteryBudget: number;
  glassBudget: number;
  tiresUndercarriageBudget: number;
  bodyWorkBudget: number;
  mechanicalBudget: number;
  deIdentifyBudget: number;
  miscBudget: number;


  public static getBudgetFromAssetAndAssetPackage(asset: Asset, assetControlGroup: AssetPackageDto): BudgetInfo {
    const budgetInfo = new BudgetInfo();
    budgetInfo.assetRnrBudget = asset.rnrBudget ? asset.rnrBudget : 0;
    budgetInfo.assetHaulingBudget = asset.haulingBudget ? asset.haulingBudget : 0;
    budgetInfo.rnrNotToExceed = assetControlGroup.rnrBudgetLimit ? assetControlGroup.rnrBudgetLimit : assetControlGroup.rnrBudgetRollup ;
    budgetInfo.haulingNotToExceed = assetControlGroup.haulingBudgetLimit ? assetControlGroup.haulingBudgetLimit : assetControlGroup.haulingBudgetRollup ;
    budgetInfo.rnrRollup = assetControlGroup.rnrBudgetRollup;
    budgetInfo.haulingRollup = assetControlGroup.haulingBudgetRollup;
    budgetInfo.opportunityCurrency = assetControlGroup.currency;
    budgetInfo.oldRnrBudget = asset.rnrBudget;
    budgetInfo.oldHaulingBudget = asset.haulingBudget;
    budgetInfo.assetPackageRnRNotToExceed = assetControlGroup.rnrBudgetLimit;
    budgetInfo.assetPackageHaulingNotToExceed = assetControlGroup.haulingBudgetLimit;
    return budgetInfo;
  }

}
